<template>
  <div class="tab-content delivery-requests-tab-content">
    <div id="top" class="tab-pane" :class="activeTab('top')">
      <top v-if="hasWarehouseUsing"
        :currentTab="tab"
      />
    </div>
    <div id="delivery-request-list" class="tab-pane" :class="activeTab('delivery-request-list')">
      <delivery-request-list
        v-if="hasWarehouseUsing"
        :currentTab="tab"
      />
    </div>
    <div id="delivery-request-registration" class="tab-pane" :class="activeTab('delivery-request-registration')">
      <delivery-request-registration
        v-if="tab !== 'update-delivery-request-registration' && hasWarehouseUsing"
        :currentTab="tab"
      />
    </div>
    <div id="delivery-request-registration" class="tab-pane" :class="activeTab('update-delivery-request-registration')">
      <update-delivery-request-registration
        v-if="tab === 'update-delivery-request-registration' && hasWarehouseUsing"
        :currentTab="tab"
      />
    </div>
    <div id="expense-detail-actual-shipment" class="tab-pane" :class="activeTab('expense-detail-actual-shipment')">
      <expense-detail-actual-shipment
        :currentTab="tab"
      />
    </div>
    <div id="expense-detail-storage-fee" class="tab-pane" :class="activeTab('expense-detail-storage-fee')">
      <expense-detail-storage-fee
        :currentTab="tab"
      />
    </div>
    <div id="receive-amount-diff-setting" class="tab-pane" :class="activeTab('receive-amount-diff-setting')">
      <receive-amount-diff-setting
        :currentTab="tab"
      />
    </div>
  </div>
</template>
<script>
import Top from './Top'
import DeliveryRequestList from './DeliveryRequestList'
import DeliveryRequestRegistration from './DeliveryRequestRegistration'
import UpdateDeliveryRequestRegistration from './UpdateDeliveryRequestRegistration'
import ExpenseDetailActualShipment from './ExpenseDetailActualShipment'
import ExpenseDetailStorageFee from './ExpenseDetailStorageFee'
import ReceiveAmountDiffSetting from './ReceiveAmountDiffSetting'
import UsagePlanManagement from './UsagePlanManagement'

export default {
  components: {
    Top,
    DeliveryRequestList,
    DeliveryRequestRegistration,
    UpdateDeliveryRequestRegistration,
    ExpenseDetailActualShipment,
    ExpenseDetailStorageFee,
    UsagePlanManagement,
    ReceiveAmountDiffSetting
  },
  props: {
    tab: {
      type: String,
      default: 'top'
    },
    hasWarehouseUsing: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /*
     * Check tab is active or not
     *
     * @param {String} tabName Tab's name
     *
     * @return {String}
     */
    activeTab (tabName) {
      return this.tab === tabName ? 'active' : ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/deliveryRequests/TabContent.vue